import {type NodeValue} from '../../../values/nodes/NodeData'
import {type ThreatMeasure, type ThreatMeasureMap} from '../../../values/ThreatMeasure'

export interface ThreatMeasuresReduxState {
    isFetchingThreatMeasures: boolean
    threatMeasures: ThreatMeasureMap
}

export const DEFAULT_THREAT_MEASURES_STATE: ThreatMeasuresReduxState = {
    isFetchingThreatMeasures: true,
    threatMeasures: new Map<NodeValue, ThreatMeasure>(),
}
